package com.essntl.uikit.components.chat.conversation

import com.essntl.uikit.components.chat.conversation.overviewcard.ConversationOverviewUiState

data class ConversationListUiState(
    val conversations: List<ConversationOverviewUiState>,
    val filterOptions: ConversationFilterOptions,
)